<template>
  <div class="shoushi_project2_wrap">
    <headerBlack-view></headerBlack-view>
    <div class="introduce_wrap">
      <div class="introduce flex-layout">
        <div class="introduce_left">
          <div class="introduce_title flex-layout">
            <img src="@/assets/yunqiao/menu.png" />
            <div class="flex-column">
              <span>项目介绍</span>
              <img src="@/assets/yunqiao/introduce.png" />
            </div>
          </div>
          <div class="introduce_name">全学科互联网 项目式学习</div>
          <div class="introduce_detail">
            遴选项目校，依据理论与实践相结合的原则对学生科学、技术、工程、
            数学等领域的教育进行自然融合，形成新的教育整体。以课堂教育学习使学生掌握多样化的理论技能，
            结合课外项目让理论技能加以验证。
            通过参与权威赛事增强青少年学习能力、创造信心，开拓学生视野。
          </div>
        </div>
        <div class="introduce_right flex-layout">
          <div class="introduce_item flex-column-center">
            <img src="@/assets/yunqiao/fusion.png" />
            <span>科学融合</span>
            <span>Fusion Discipline</span>
          </div>
          <div class="introduce_item flex-column-center">
            <img src="@/assets/yunqiao/internet.png" />
            <span>网络互联</span>
            <span>Internet Network</span>
          </div>
          <div class="introduce_item flex-column-center">
            <img src="@/assets/yunqiao/stimulate.png" />
            <span>激发创造力</span>
            <span>Stimulate Creativity</span>
          </div>
        </div>
      </div>
    </div>
    <div class="feature_wrap">
      <div class="feature_top flex-layout">
        <img src="@/assets/yunqiao/menu.png" />
        <div class="flex-column">
          <span>产品特点</span>
          <img src="@/assets/yunqiao/feature.png" />
        </div>
      </div>
      <div class="feature_bottom flex-align-between">
        <div class="feature_item flex-column-center">
          <div class="number flex-align-around">01</div>
          <p>覆盖范围广</p>
          <p>学前教育至博士后</p>
          <p>所有年级水平的教育活动</p>
        </div>
        <img src="@/assets/yunqiao/add.png" class="add" />
        <div class="feature_item flex-column-center">
          <div class="number flex-align-around">02</div>
          <p>互联互通</p>
          <p>以互联网为依托</p>
          <p>进行学科融合式学习</p>
        </div>
        <img src="@/assets/yunqiao/add.png" class="add" />
        <div class="feature_item flex-column-center">
          <div class="number flex-align-around">03</div>
          <p>多样化</p>
          <p>使青少年能够多样化发展</p>
          <p>同时提升创造能力</p>
        </div>
      </div>
    </div>
    <div class="architecture_wrap">
      <div class="architecture">
        <div class="architecture_top flex-layout">
          <img src="@/assets/yunqiao/menu.png" />
          <div class="flex-column">
            <span>架构形式</span>
            <img src="@/assets/yunqiao/architecture.png" />
          </div>
        </div>
        <div class="architecture_bottom flex-align-between">
          <div class="architecture_left flex-column-between">
            <div class="flex-layout architecture_item">
              <div class="circle flex-align-around">
                <img src="@/assets/yunqiao/jiagou1.png" />
              </div>
              <div class="flex-column">
                <p>覆盖范围广</p>
                <p>提升学生动手创造能力为核心，通过提升学生多样化学习特性，实现学生的全面发展。</p>
              </div>
            </div>
            <div class="flex-layout architecture_item">
              <div class="circle flex-align-around">
                <img src="@/assets/yunqiao/jiagou3.png" />
              </div>
              <div class="flex-column">
                <p>练兵</p>
                <p>
                  项目成果练兵，以“全国青少年创新大赛”、“中国青少年机器人竞赛”、“
                  全国青少年创意编程与智能设计大赛”为目标，让学生的创造能力得以体现。
                </p>
              </div>
            </div>
          </div>
          <div class="architecture_right flex-column-between">
            <div class="flex-layout architecture_item">
              <div class="circle flex-align-around">
                <img src="@/assets/yunqiao/jiagou2.png" />
              </div>
              <div class="flex-column">
                <p>正式教育 非正式教育</p>
                <p>
                  通过正式教育（课堂教育）使学生掌握对应学科理论技能，
                  结合非正式教育（课外项目）达成理论与实践相结合，让实践是检验真理的唯一
                  标准不再停留在书本上。
                </p>
              </div>
            </div>
            <div class="flex-layout architecture_item">
              <div class="circle flex-align-around">
                <img src="@/assets/yunqiao/jiagou4.png" />
              </div>
              <div class="flex-column">
                <p>多领域依托互联网</p>
                <p>
                  以科学、技术、工程和数学为首的教育领域、全学段依托互联网络进行融合，
                  形成全新的教育整体，通过互联网技术使学科间融合更加自然。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="win_wrap">
        <div class="win_top flex-layout">
          <img src="@/assets/yunqiao/menu.png" />
          <div class="flex-column">
            <span>合作共赢</span>
            <img src="@/assets/yunqiao/win2.png" />
          </div>
        </div>
        <div class="win_bottom flex-align-between">
          <div class="win_item flex-column-center">
            <img src="@/assets/yunqiao/win_item6.png" />
            <span>Discipline Integration</span>
            <span>多学科自然融合</span>
          </div>
          <div class="win_item flex-column-center">
            <img src="@/assets/yunqiao/win_item7.png" />
            <span>Learning Period</span>
            <span>全学段覆盖</span>
          </div>
          <div class="win_item flex-column-center">
            <img src="@/assets/yunqiao/win_item8.png" />
            <span>Enrich Interactive</span>
            <span>丰富互动活动项目</span>
          </div>
          <div class="win_item flex-column-center">
            <img src="@/assets/yunqiao/win_item9.png" />
            <span>Ability to Ascend</span>
            <span>学生创造能力提升</span>
          </div>
          <div class="win_item flex-column-center">
            <img src="@/assets/yunqiao/win_item10.png" />
            <span>Learner Interaction</span>
            <span>学习者互动交流</span>
          </div>
        </div>
      </div>
    </div>

    <footer-view></footer-view>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less">
@import "./less/shoushi_project2.less";
</style>